import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { useFeatureAuth } from "../../auth/hooks/use-feature-auth";

/**
 * useOmniProcessAvailable returns whether the user may see and create omni
 * processes, i.e. processes without a service kind, see
 * `process.Process.ServiceKind`,
 * backend/core/processes/domain/process/process.go.
 */
export function useOmniProcessAvailable(): boolean {
  const released = useBooleanFlagValue("gsm.omni", true);
  const canAccess = useFeatureAuth("gsm.omni");

  return released && canAccess;
}
